import React from 'react';
import { ErrorComponents } from '@css-xp/base';

interface Props {
  errorMessage?: string;
}

const ErrorNotificationMessage = ({ errorMessage }: Props) => {
  return (
    <>
      {errorMessage ? (
        <p className="action-modal-notification" data-testid="error-notification-msg">
          {errorMessage}
        </p>
      ) : (
        <p className="action-modal-notification" data-testid="error-notification-msg">
          Looks like something went wrong - try again in a few minutes. Still having trouble? Contact the{' '}
          <ErrorComponents.ChatRoomLink />
        </p>
      )}
    </>
  );
};

export default ErrorNotificationMessage;
